module.exports = __webpack_public_path__ + "static/media/Colette Single Bed Base - 120x200 cm_Black.2a4ebf8e.png";